

















import {
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import InvestmentLineChart from "@/shared/components/charts/InvestmentLineChart.vue";
import { mixins } from "vue-class-component";
import { formatCurrency } from "@/shared/currency";
import {
  InvestmentCustodian,
  DrivewealthAccountIdentifierArgs
} from "@/shared/types";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useDrivewealthAccountPerformanceStore } from "@/shared/store/drivewealthAccountPerformance";
import AccountPerformanceForm from "@/employee/components/investments/drivewealth/AccountPerformanceForm.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InvestmentBalancePanel from "@/shared/components/investments/drivewealth/InvestmentBalancePanel.vue";

@Component({
  components: {
    GenericLoadingSpinner,
    AccountPerformanceForm,
    InvestmentLineChart,
    InvestmentBalancePanel
  }
})
export default class CurrentHoldingsChart extends mixins(ErrorsMixin) {
  formatCurrency = formatCurrency;

  drivewealthStore = useDrivewealthStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  drivewealthAccountPerformanceStore = useDrivewealthAccountPerformanceStore();

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  accountId: number;

  @Prop({ required: false })
  hideInvestmentChart: boolean;

  @Prop({ required: false })
  usePerformanceData: boolean;

  loadChart (): void {
    this.drivewealthStore.getAccountSummaryV2({
      username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId
    });

    this.drivewealthStore.loadHsaBalanceAndThreshold({
      username: this.username, partnerId: this.partnerId, accountId: this.accountId
    });
  }

  @Watch("$props", { deep: true })
  reload () {
    this.loadChart();
  }

  mounted (): void {
    this.loadChart();
  }

  get accountIdentifiers (): DrivewealthAccountIdentifierArgs {
    return {
      username: this.username,
      partnerId: this.partnerId,
      accountId: this.accountId
    };
  }

  get performanceDataLoading (): boolean {
    return this.drivewealthAccountPerformanceStore.accountPerformanceLoading(this.accountIdentifiers);
  }

  get isLoaded (): boolean {
    const accountSummaryV2Loaded = this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
    const balanceThresholdLoaded = this.drivewealthStore.isHsaBalanceAndThresholdLoaded(this.accountId);

    return accountSummaryV2Loaded &&
        balanceThresholdLoaded;
  }

  get isLoading (): boolean {
    return !this.isLoaded;
  }
}
